import { __rest } from "tslib";
import React, { useState, useCallback, useRef } from "react";
import Modal, { ModalType } from "Shared/Modal";
import { translate } from "Shared/translate";
import { get, set } from "Shared/session-storage";
import Dialog, { DialogType } from "Shared/Dialog";
import Checkbox from "Shared/Fields/Checkbox";
import cookieHandler from "./../../../Helpers/cookieHandler";
import * as styles from "./base.scss";
import classnames from "classnames";
import { pushState } from "Shared/history";
import { trackButtonClick } from "../../TrackingInformation";
const STORAGE_KEY = "alcohol";
export default function LinkWithAlcoholWarning(_a) {
    var { onClick, href, children, targetLink, hasAlcoholWarning, wrap, text } = _a, restProps = __rest(_a, ["onClick", "href", "children", "targetLink", "hasAlcoholWarning", "wrap", "text"]);
    let linkRef = useRef();
    const linkProps = { href: targetLink ? targetLink.url : href };
    if (targetLink && targetLink.openInNewWindow) {
        linkProps.target = "_blank";
    }
    const [isOpen, setOpen] = useState(false);
    const [isChoiceRemembered, setChoiceRemembered] = useState(false);
    var handleGA4ButtonClick = function () {
        try {
            trackButtonClick(linkProps.href, text);
        }
        catch (error) {
            console.error("GA4 tracking failed:", error);
        }
    };
    const handleClose = useCallback(() => setOpen(false), []);
    const handleConfirm = useCallback(() => {
        if (isChoiceRemembered) {
            cookieHandler.setCookie(STORAGE_KEY, "true", 0, true);
            set(STORAGE_KEY, true);
        }
        return pushState(linkProps.href, { hideSpinner: true });
    }, [linkProps.href, isChoiceRemembered]);
    const handleLinkClick = useCallback((e) => {
        handleGA4ButtonClick();
        const needsAgeConfirm = !get(STORAGE_KEY);
        if (hasAlcoholWarning && needsAgeConfirm) {
            setOpen(true);
            e.preventDefault();
            return false;
        }
        !!onClick && onClick(e);
    }, [hasAlcoholWarning]);
    const toggleRemember = () => {
        setChoiceRemembered((state) => !state);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("a", Object.assign({ ref: linkRef, onClick: handleLinkClick, "data-may-prevent-default": true }, restProps, linkProps, { className: classnames(!wrap && styles.nonWrap, linkProps.className, restProps.className) }),
            wrap && children,
            !wrap && !!text && React.createElement("span", { className: styles.hidden }, text)),
        !wrap && children,
        React.createElement(Modal, { title: translate("/AlcoholModal/Header"), isOpen: isOpen, onClose: handleClose, type: ModalType.Warning, reserveSpaceForCloseButton: true },
            React.createElement("p", null, translate("/AlcoholModal/Body")),
            React.createElement("label", { className: styles.remember },
                React.createElement(Checkbox, { onChange: toggleRemember, checked: isChoiceRemembered }),
                React.createElement("span", null, translate("/AlcoholModal/RememberThisChoice"))),
            React.createElement(Dialog, { type: DialogType.YesNo, onConfirm: handleConfirm, onCancel: handleClose, customAcceptText: translate("/AlcoholModal/Accept"), customDeclineText: translate("/AlcoholModal/Decline") }))));
}
